import PropTypes from 'prop-types';
import React from 'react';
import RefreshIcon from '@atlaskit/icon/glyph/refresh';
import Incident from './incident';
import Component from './component';

const Page = ({ statusPageURL, name, incidents, components }) => {
  const renderedIncidents = incidents.map(incident => <Incident {...incident} key={incident.id} />);
  const renderedComponents = components.map(component => (
    <Component {...component} key={component.id} />
  ));
  const pageOverview = incidents.length + components.length > 0
    ? (<div>
      <div className="incidents">{renderedIncidents}</div>
      <div className="components">{renderedComponents}</div>
    </div>)
    : <div className="empty-state">All Operational</div>;

  return (
    <div className="page">
      <div className="page-url">
        <a title={name} className="page-name" href={statusPageURL} target="_blank" rel="noopener noreferrer">{name}</a>
        <button className="page-refresh-button" type="button" onClick={() => location.reload()} >
          <RefreshIcon label="Refresh" size="small" primaryColor="inherit" secondaryColor="inherit" />
        </button>
      </div>
      <div style={{ clear: 'both' }} />
      {pageOverview}
    </div>
  );
};

Page.propTypes = {
  statusPageURL: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  incidents: PropTypes.arrayOf(PropTypes.shape(Incident.propTypes)).isRequired,
  components: PropTypes.arrayOf(PropTypes.shape(Component.propTypes)).isRequired,
};

export default Page;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride/sidebar/page.jsx